var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-with-top-bar"},[_c('project-admin-quick-buttons',{attrs:{"hiddenOption":"pictograms"}}),_vm._v(" "),_c('section',{staticClass:"p-4"},[_c('pictogram-admin-panel',{attrs:{"pictogramId":_vm.pictogramId},on:{"epc-go-back":_vm._HandleGoBack}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }